module.exports = __webpack_public_path__ + "static/media/testing.cab4488e.png";